import Icon from '../components/Icon.vue'

Icon.register({
  'bus-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 128c13.3 0 24 10.7 24 24v80c0 13.3-10.8 24-24 24h-8v166.4c0 12.8-9.6 25.6-25.6 25.6h-6.4v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-192v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32v-160h-8c-13.3 0-24-10.8-24-24v-80c0-13.3 10.8-24 24-24h8v-48c0-44.8 99.2-80 224-80s224 35.2 224 80v48h8zM160 72v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-176c-4.4 0-8 3.6-8 8zM112 400c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM240 288v-160h-112c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h112zM272 288h112c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32h-112v160zM400 400c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bus-alt.js
// module id = 1127
// module chunks = 0